module.exports = "img/photo4.3d1eff.jpg";